module.exports = __webpack_public_path__ + "img/Fake_Video-6.4bb22cbe.jpg";